<template>
  <div class="right_body" v-loading.fullscreen.lock="loading">
    <el-checkbox-group :indeterminate="isIndeterminate" v-model="checkList" @change="getCheckList">
    <table>
      <thead>
        <th width="160">主模块</th>
        <th width="160">子模块</th>
        <th width="180">菜单</th>
        <th>功能</th>
      </thead>
    </table>
    <table class="resource_tab"> 
      <tr v-for="(item,index) in resourceList" :key="index">
        <td width="160"><el-checkbox :label="item.resourceId" @change="getChild($event,item,1)">{{item.resourceName}}</el-checkbox></td>
        <td class="child_table_td">
          <table v-if="item.children">
            <tr v-for="(vitem,vindex) in item.children" :key="vindex">
              <td width="160"><el-checkbox :label="vitem.resourceId" @change="getChild($event,vitem)">{{vitem.resourceName}}</el-checkbox></td>
              <td class="child_table_td">
                <table v-if="vitem.children">
                  <tr v-for="(vvitem,vvindex) in vitem.children" :key="vvindex">
                    <td width="180"><el-checkbox :label="vvitem.resourceId" @change="getChild($event,vvitem)">{{vvitem.resourceName}}</el-checkbox></td>
                    <td>
                      <div class="action_box" v-if="vvitem.children">
                        <el-checkbox v-for="(vvvitem,vvvindex) in vvitem.children" :key="vvvindex" :label="vvvitem.resourceId" @change="getChild($event,vvvitem)">{{vvvitem.resourceName}}</el-checkbox>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </el-checkbox-group>
  <div class="role_btn">
    <button @click.stop="addAuth" class="btn">确定</button>
  </div>

    <!--
    <el-tree
      :data="resourceList"
      show-checkbox
      default-expand-all
      node-key="resourceId"
      @check-change="handleCheckChange"
      :props="defaultProps">
    </el-tree> -->
  </div>
</template>
<script>
import {resource,roleRsc} from 'api/auth.js'
export default{
  data(){
    return{
      loading:false,
      isIndeterminate:true,
      rid:0,
      slist:[],//未变成树型数组
      resourceList:[],//资源列表
      selectList:[],//已选资源
      selectChildList:[],//当前所有子节点
      checkList:[],
      defaultProps: {
        children: 'children',
        label: 'resourceName'
      },
      tabColumns:[
        {field: 'resourceName', title: '主导航', width:120},
        {field: 'childResourceName', title: '子模块'},
        {field: '', title: '菜单', width:100},
        {field: '', title: '功能'}
      ],//表头字段
    }
  },
  created(){
  	this.getListArr();
  },
  methods:{
    //递归成树状
    filterArray(data, parent,level = 0){
      level++;
      var tree = [];
      var temp;
      for (var i = 0; i < data.length; i++) {
        if (data[i].parentResourceId == parent) {
          let levelStr = "";
          for(var j=1;j<level;j++){
            levelStr = levelStr + '|- ';
          }
          data[i].level = level;
          data[i].value = levelStr + data[i].resourceName;
          var obj = data[i];
          temp = this.filterArray(data, data[i].resourceId,level);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },
    //获取列表
    async getListArr(){
      let rid = this.$route.params.id;
      //let resourceList = await this.$post(resource.list,this.$store.state.getAllPage);
      let resourceList = await this.$get(roleRsc.auth,{"roleId":rid});
      if(resourceList.status && resourceList.data){
        this.slist = resourceList.data;
        this.resourceList = this.filterArray(resourceList.data,0);
        console.log(this.slist)
        this.slist.forEach((item)=>{
          if(item.roleId){
            this.checkList.push(item.resourceId);
          }
        });
      }else{
        this.resourceList = [];
      }
      this.resourceList.forEach((item)=>{
        let rowspan = 0;
        let rowspanChild = 1;
        let rowspanChildName = "";
        let rowspanChildId = 0;
        if(item.children){
          rowspan = rowspan + item.children.length;
          if(item.children){
            rowspan = 0;
            //第二级
            item.children.forEach((vitem,index)=>{
              let tempLen = 0;
              if(vitem.children){
                tempLen = vitem.children.length;
                rowspan = rowspan + vitem.children.length;
              }else{
                tempLen = 1;
              }
              vitem.rowspan = tempLen;
            });
            rowspanChild = item.children[0].children ? item.children[0].children.length : 1;
            rowspanChildName = item.children[0].resourceName ? item.children[0].resourceName : "";
            rowspanChildId = item.children[0].resourceId ? item.children[0].resourceId : 0;
          }
        }else{
          rowspan = 1;//第一级
          rowspanChild = 1;//第二级
        }
        item.rowspan = rowspan;//第一级
        item.rowspanChild = rowspanChild;//第二级
        item.rowspanChildName = rowspanChildName;
        item.rowspanChildId = rowspanChildId;
      });
      //console.log(this.resourceList,'=== 成树状的 ==');

    },

    //添加角色权限
    async addAuth(){
      if(!this.checkList.length){
        this.$message.error("请选择权限");
        return;
      }
      let aid = this.$route.params.id;
      this.loading = true;
      let authArr = [];
      this.checkList.forEach((item)=>{
        if(item){
          let temp = {};
          temp.roleId = aid;
          temp.resourceId = item;
          authArr.push(temp);
        }
      });
      //console.log(authArr);
      let res = await this.$post(roleRsc.add,authArr);
      //console.log(res,'======  返回结果 ====');
      //console.log(JSON.stringify(authArr));
      if(res.status){
        this.$message.success(res.msg);
      }else{
        this.$message.error("设置权限失败");
      }
      this.loading = false;
      //console.log(res,'5555566666');
      //console.log(authArr,6666);
    },

    getCheckList(){
      this.checkList.forEach((item)=>{
        this.selectParent(item);
      });
    },

    //已选-找父级
    selectParent(pid){
      let obj = this.slist.find(v=>v.resourceId === pid);
      if(obj){
        let isParent = this.checkList.findIndex(vi=> vi == obj.parentResourceId);
        if(isParent === -1){
          this.checkList.push(obj.parentResourceId);
        }
        this.selectParent(obj.parentResourceId);
      }
    },

    //已选 - 找所有的子级
    selectChild(cid){
      for(var i=0;i<this.slist.length;i++){
        if(this.slist[i].parentResourceId === cid){
          this.selectChildList.push(this.slist[i].resourceId);
          this.selectChild(this.slist[i].resourceId);
        }
      }
    },

    //获取当前所先
    getChild(val,item,type){
      //type 1读resourceId  2读取 rowspanChildId 3
      this.selectChildList = [];
      if(type == 2){
        this.selectChild(item.rowspanChildId);
      }else{
        this.selectChild(item.resourceId);
      }
      if(val){
        this.selectChildList.forEach((item)=>{
          let isParent = this.checkList.findIndex(v=> v === item);
          if(isParent === -1){
            this.checkList.push(item);
          }
        });
      }else{
        this.selectChildList.forEach((item)=>{
          let idIndex = this.checkList.findIndex(v=> v === item);
          if(idIndex != -1){
            this.checkList.splice(idIndex,1);
          }
        });
      }

    }
  }
}
</script>

<style>
.resource_tab .child_table_td{padding:0;}
.resource_tab table{border: 0 none;}
.resource_tab table td{border:0 none;border-right: 1px solid #ebeef5;}
.resource_tab table td:last-child{border-right: 0 none;}
.resource_tab table tr{border-bottom:1px solid #ebeef5;}
.resource_tab table tr:last-child{border:0 none;}
.role_btn{
  text-align: center;
  padding:20px 0;
}
.role_btn .btn{
  display: inline-block;
  padding:8px 16px;
  color:#FFFFFF;
}
</style>
